/** A first-of-month ISO date (`2026-08-01`) as the month and year (`August 2026`). */
export function formatMonth(isoMonth: string, language: string): string {
  const [year, month] = isoMonth.split("-").map(Number);
  return new Date(year, month - 1, 1).toLocaleDateString(language, { month: "long", year: "numeric" });
}
